import { ApiError } from "api/shared";
import { AxiosError } from "axios";
import { Redirect } from "react-router-dom";

import { routes } from "config/urls";

interface ErrorFallbackProps {
  error?: AxiosError<ApiError>;
  customError?: string;
  customStatusCode?: number;
}

export const ErrorFallback = ({
  error,
  customError,
  customStatusCode,
}: ErrorFallbackProps) => {
  const pathname =
    error?.response?.status === 404 || error?.response?.status === 402
      ? routes.notfound
      : routes.error;

  let search = error?.response?.data.correlationId
    ? `?x-correlation-id=${error.response?.data.correlationId}`
    : "";

  if (pathname === routes.error) {
    if (error?.response?.status ?? customStatusCode)
      search += `${search ? "&errorCode=" : "?errorCode="}${
        error?.response?.status ?? customStatusCode
      }`;

    if (
      error?.response?.status === 400 &&
      error?.response?.data.detailedErrorCode === 4000
    ) {
      search += `${search ? "&" : "?"}errorMessage=Invalid redirect URL`;
    }

    if (!error && customError) {
      search += `${search ? "&" : "?"}errorMessage=${customError}`;
    }
  }

  return (
    <Redirect
      to={{
        pathname,
        search,
      }}
      push={true}
    />
  );
};
